import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_2 = { class: "col-span-4 sm:col-span-4" }
const _hoisted_3 = {
  class: "block text-sm font-medium text-gray-700",
  for: "profileDisplayName"
}
const _hoisted_4 = { class: "col-span-4 sm:col-span-4" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "divide-y divide-gray-200" }
const _hoisted_7 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_8 = { class: "col-span-4" }
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = { class: "mt-10 divide-y divide-gray-200" }
const _hoisted_11 = { class: "space-y-1" }
const _hoisted_12 = { class: "text-xl font-bold leading-6 text-gray-900" }
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = { class: "px-6 pb-6 divide-y bg-clay-50 divide-clay-200" }
const _hoisted_15 = { class: "mt-6" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "space-y-5" }
const _hoisted_18 = { class: "grid gap-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_19 = { class: "relative flex items-start" }
const _hoisted_20 = { class: "flex items-center h-5" }
const _hoisted_21 = ["id", "name", "value"]
const _hoisted_22 = { class: "ml-3 text-sm" }
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "px-6 pb-6 divide-y bg-clay-50 divide-clay-200" }
const _hoisted_25 = { class: "mt-6" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "space-y-5" }
const _hoisted_28 = { class: "grid gap-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_29 = { class: "relative flex items-start" }
const _hoisted_30 = { class: "flex items-center h-5" }
const _hoisted_31 = ["id", "name", "value"]
const _hoisted_32 = { class: "ml-3 text-sm" }
const _hoisted_33 = ["for"]
const _hoisted_34 = { class: "px-6 pb-6 divide-y bg-clay-50 divide-clay-200" }
const _hoisted_35 = { class: "mt-6" }
const _hoisted_36 = { class: "space-y-5" }
const _hoisted_37 = { class: "grid gap-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_38 = { class: "relative flex items-start" }
const _hoisted_39 = { class: "flex items-center h-5" }
const _hoisted_40 = ["id", "name", "value"]
const _hoisted_41 = { class: "ml-3 text-sm" }
const _hoisted_42 = ["for"]
const _hoisted_43 = { class: "py-3 mt-10 text-center" }

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetProfileRegion, GetProfileRegionResponse,
    GetProfileSettingBasics,
    GetProfileSettingBasicsResponse,
    Region, UpdateProfileRegion,
    UpdateProfileSettingBasics
} from "@/dtos";
import {
  GetAllTerritories
} from "@/dtos";
// @ts-ignore
import {SparklesIcon, TrashIcon} from '@heroicons/vue/20/solid';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import TerritoriesTab from "@/../Features/Territories/TerritoriesTab.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateProfileBasics',
  setup(__props) {

// @ts-ignore
let responseStatus = ref(null);
let profile: Ref<GetProfileSettingBasicsResponse> = ref(new GetProfileSettingBasicsResponse());
let updateSuccessful: Ref<Boolean> = ref(false);

const territories: Ref<Array<Region>> = ref([]);
const userPreferredRegion: Ref<Region> = ref(new Region());
const territoryQuery = ref('');

onMounted(async () => {
    await client.get<Array<Region>>(new GetAllTerritories())
        .then(res => {
            territories.value = res.sort((a: Region, b: Region) => a.name.localeCompare(b.name));
        });

    await client.get<GetProfileSettingBasicsResponse>(new GetProfileSettingBasics())
        .then(response => {
            profile.value = response;
        });

    await client.get<GetProfileRegionResponse>(new GetProfileRegion())
        .then(res => {
            userPreferredRegion.value = res.closestRegionForUser;
        });
});

let filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? territories.value
        : territories.value.filter((territory: Region) => {
              return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const onRegionSelected = async (territory: Region) => {
    userPreferredRegion.value = territory;
    updateSuccessful.value = false;
    await client.post(new UpdateProfileRegion({territoryId: userPreferredRegion.value.id}))
        .then(response => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
}

const isSubmitting = ref(false);
const submit = async () => {
  isSubmitting.value = true;
  updateSuccessful.value = false;
  let request = profile.value;
  
  await client.post<ResponseStatus>(new UpdateProfileSettingBasics(request))
      .then(_ => {
        updateSuccessful.value = true;
        responseStatus.value = null;
      })
      .catch(e => {
        responseStatus.value = e.responseStatus;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    isSubmitting.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _cache[6] || (_cache[6] = _createTextVNode("Profile Display Name ")),
            _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "profileDisplayName",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(profile).profileDisplayName) = $event)),
            class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-500 sm:text-sm",
            name: "profileDisplayName",
            type: "text"
          }, null, 512), [
            [_vModelText, _unref(profile).profileDisplayName]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Region", -1)),
          _createVNode(TerritoriesTab, {
            territories: territories.value,
            modelValue: userPreferredRegion.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userPreferredRegion).value = $event)),
            onOnRegionSelected: onRegionSelected
          }, null, 8, ["territories", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "z-40",
                "x-cloak": "",
                "x-data": "dropdown"
              }, [
                _createElementVNode("div", { class: "items-center justify-between text-sm" }, [
                  _createElementVNode("div", { class: "" }, [
                    _createElementVNode("span", { class: "inline-block text-sm font-medium text-powder-800" }, "Introduction"),
                    _createElementVNode("button", {
                      "aria-controls": "introSample",
                      "aria-expanded": "true",
                      "aria-label": "Toggle Introduction Sample",
                      class: "inline-block pl-3 font-medium text-powder-600 hover:text-powder-500",
                      type: "button",
                      "x-on:click": "toggle"
                    }, [
                      _createElementVNode("i", { class: "far fa-question-circle" })
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  id: "introSample",
                  "aria-labelledby": "menu-button",
                  "aria-orientation": "vertical",
                  class: "items-center justify-between p-5 my-2 mb-5 bg-powder-50 rounded-2xl",
                  role: "menu",
                  tabindex: "-1",
                  "x-show": "open"
                }, [
                  _createElementVNode("span", { class: "block font-medium" }, "Sample Introduction:"),
                  _createTextVNode(" Hello and welcome to my StageAgent page! I’ve performed leading roles in both amateur and professional theatre productions, playing characters from evil villains to extreme comic buffoons. I am a classically trained vocalist, an expert tap dancer and studied acting under Professor Edward Graves at NYU. I currently reside in New York City and am actively looking for new engagements. ")
                ])
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                for: "intro",
                class: "block text-sm font-medium text-gray-700 sr-only"
              }, "Introduction", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(profile).intro) = $event)),
                  class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-500 sm:text-sm",
                  id: "intro",
                  name: "intro",
                  rows: "4"
                }, null, 512), [
                  [_vModelText, _unref(profile).intro]
                ])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "max-w-2xl mt-1 text-sm text-clay-800" }, "Maximum characters: 400", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", _hoisted_12, [
            _cache[11] || (_cache[11] = _createTextVNode("Roles ")),
            _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" }, "Select your areas of expertise", -1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "max-w-2xl pt-6 font-bold text-clay-900" }, "Performer", -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("fieldset", _hoisted_17, [
                    _cache[15] || (_cache[15] = _createElementVNode("legend", { class: "sr-only" }, "Performer types", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profile).performerRolesOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                              id: option,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(profile).performerRoles) = $event)),
                              name: option,
                              value: option,
                              "aria-describedby": "",
                              class: "w-4 h-4 rounded border-clay-500 text-powder-600 focus:ring-powder-500",
                              type: "checkbox"
                            }, null, 8, _hoisted_21), [
                              [_vModelCheckbox, _unref(profile).performerRoles]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", {
                              for: option,
                              class: "font-medium text-gray-700"
                            }, _toDisplayString(option), 9, _hoisted_23),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                          ])
                        ]))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "max-w-2xl pt-6 font-bold text-clay-900" }, "Artistic Staff", -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _createElementVNode("fieldset", _hoisted_27, [
                    _cache[19] || (_cache[19] = _createElementVNode("legend", { class: "sr-only" }, "Artistic staff types", -1)),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profile).staffRolesOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              id: option,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(profile).staffRoles) = $event)),
                              name: option,
                              value: option,
                              "aria-describedby": "",
                              class: "w-4 h-4 rounded border-clay-500 text-powder-600 focus:ring-powder-500",
                              type: "checkbox"
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, _unref(profile).staffRoles]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", {
                              for: option,
                              class: "font-medium text-gray-700"
                            }, _toDisplayString(option), 9, _hoisted_33),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                          ])
                        ]))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "max-w-2xl pt-6 font-bold text-clay-900" }, "Teacher", -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("fieldset", _hoisted_36, [
                    _cache[23] || (_cache[23] = _createElementVNode("legend", { class: "sr-only" }, "Teacher types", -1)),
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profile).teacherRolesOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _withDirectives(_createElementVNode("input", {
                              id: option,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(profile).teacherRoles) = $event)),
                              name: option,
                              value: option,
                              "aria-describedby": "",
                              class: "w-4 h-4 rounded border-clay-500 text-powder-600 focus:ring-powder-500",
                              type: "checkbox"
                            }, null, 8, _hoisted_40), [
                              [_vModelCheckbox, _unref(profile).teacherRoles]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", {
                              for: option,
                              class: "font-medium text-gray-700"
                            }, _toDisplayString(option), 9, _hoisted_42),
                            _cache[21] || (_cache[21] = _createTextVNode()),
                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-clay-800" }, null, -1))
                          ])
                        ]))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(SaButton, {
          onClick: _withModifiers(submit, ["prevent"]),
          loading: isSubmitting.value,
          variant: "primary"
        }, null, 8, ["loading"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: _unref(updateSuccessful),
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})